import { Component, ViewChild } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { AssessmentService } from 'src/app/services/assessment.service';

@Component({
  selector: 'app-manage-assessment-test',
  templateUrl: './manage-assessment-test.component.html',
  styleUrls: ['./manage-assessment-test.component.scss']
})
export class ManageAssessmentTestComponent {
  total: number;
  limit = 10;
  from = 0;
  assessments: any[];
  selected: any;
  @ViewChild('assessmentModal') assessmentModal: NgxSmartModalComponent;

  constructor(private assessmentService: AssessmentService) { }

  ngOnInit() { this.load(0); }

  load(from?: number) {
    delete this.assessments;
    if (from != undefined) this.from = from;
    setTimeout(async () => {
      var result = await this.assessmentService.search({}, this.from, this.limit);
      this.assessments = result.assessments;
      this.total = result.total;
    });
    this.assessmentModal?.close();
  }

  openModal(assessment?: any) {
    this.selected = Object.assign({}, assessment || {});
    this.assessmentModal.open();
  }

  addQuestion(assessment: any) {
    assessment.Questions = assessment.Questions || [];
    assessment.Questions.push({});
  }

  addOption(question: any) {
    question.Options = question.Options || [];
    question.Options.push({});
  }

  async save(assessment: any) {
    await this.assessmentService.save(assessment);
    this.load();
  }
}
